import { ArrowLeft, Music2, X } from "lucide-react";

export default function WizardHeader({ step = 1, total = 7, showProgress = true, canBack = false, onBack, onClose }) {
  const idx = Math.min(Math.max(step, 1), total) - 1;
  return (
    <div className="epw-head">
      <div className="epw-head-in">
        <div className="epw-head-card">
          <div className="epw-head-row">
            {canBack && (
              <button type="button" data-testid="wizard-back" onClick={onBack} aria-label="Назад" className="epw-iconbtn epw-backbtn">
                <ArrowLeft size={16} />
              </button>
            )}
            <span className="epw-tile" aria-hidden="true"><Music2 size={26} /></span>
            <div className="epw-head-title">
              <div className="epw-head-name">Створити пісню</div>
              {showProgress && <div className="epw-step">Крок {idx + 1} із {total}</div>}
            </div>
            <button type="button" data-testid="wizard-close" onClick={onClose} aria-label="Закрити" className="epw-iconbtn">
              <X size={18} />
            </button>
          </div>
          {showProgress && (
            <div className="epw-progress">
              {Array.from({ length: total }, (_, i) => <i key={i} className={i === idx ? "active" : ""} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
